import React from 'react';
import logo from 'media/images/logos/logo.svg';
import Box from 'js/components/box/box';
import Button from 'js/components/button/button';
import Col from 'js/components/grid/column';
import Row from 'js/components/grid/row';
import Banner from 'js/components/banner/banner';
import Text from 'js/components/text/text';
import Spinner from 'js/components/spinner/spinner';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBullhorn } from '@fortawesome/pro-light-svg-icons/faBullhorn';
import NeedHelpModal from './need-help-modal/need-help-modal';
import styles from '../quick-start.module.scss';

const SaleBanner = () => (
    <Banner color={['pink', 'dark']}>
        <Text size="large" weight="bold" color={['gray', 'white']} inline>
            <FontAwesomeIcon icon={faBullhorn} className={styles.bullhorn} />
        </Text>
        <Text size="large" weight="bold" color={['gray', 'white']} inline>
            Limited time deal{' '}
        </Text>
        <Text size="large" color={['gray', 'white']} inline>
            - 50% off display and video contexts
        </Text>
    </Banner>
);

const LandingPage = ({ loading, loadingError, onStart }) => (
    <>
        <SaleBanner />
        <div className={styles['landing-page']}>
            <div className={styles['main-content']}>
                <img className={styles.logo} src={logo} alt="4D logo" />
                <div>
                    <p className={styles.headline}>
                        Smarter contextual ads,
                        <br />
                        powered by AI
                    </p>
                    <p className={styles.subheadline}>
                        Use our AI wizard to build targeted campaigns across the
                        Open Web in minutes
                    </p>
                </div>

                <Row justifyContent="center">
                    <Col span="auto">
                        <Button onClick={onStart} disabled={loading}>
                            Start Your First Campaign
                            {loading && (
                                <Box padding={[0, 0, 0, 'small']}>
                                    <Spinner size="small" />
                                </Box>
                            )}
                        </Button>
                    </Col>
                </Row>

                {loadingError && (
                    <p className={styles.error}>
                        There was an unexpected error.
                        <br />
                        Please try again in a few moments.
                    </p>
                )}
            </div>
            <div>
                <NeedHelpModal />
            </div>
        </div>
    </>
);

export default LandingPage;
